/**
 * @param {Object|false|null|undefined} sensor
 * @returns {boolean}
 */
export function isMutedSensor(sensor) {
    return Boolean(sensor && (sensor.config === false || (sensor.config && sensor.config.alert === false)))
}

const HUMIDITY_SENSOR_TYPE = 5

/**
 * @param {Object|false|null|undefined} sensor
 * @returns {boolean}
 */
export function isHumiditySensor(sensor) {
    if (!sensor || !sensor.config || typeof sensor.config !== 'object') {
        return false
    }

    return Number(sensor.config.rmoni_type) === HUMIDITY_SENSOR_TYPE
}
